export default interface FormPosterOptions {
    host?: string;
}
